<template>
  <div class="raster-thumbnail-drawer" :id="drawerId">
    <raster-thumbnail
      v-for="(image, index) in slices"
      :key="image.imgKey"
      :image="image"
      :index="index"
      :octDataLoading="octDataLoading"
      :sliceCurrentIndex="sliceCurrentIndex"
      :octColorSettings="octColorSettings"
      :rasterThumbSize="rasterThumbSize"
      @selectSlice="$emit('selectSlice', $event)"/>
  </div>
</template>

<script>
import rasterThumbnail from "./RasterThumbnail";
export default {
  name: "rasterImageDrawer",
  components: { rasterThumbnail },
  props: {
    slices: Array,
    sliceCurrentIndex: Number,
    octDataLoading: Boolean,
    octColorSettings: Object,
    rasterThumbSize: Object,
    drawerId: { type: String, default: "raster-thumbnail-drawer" }
  }
};
</script>

<style lang="scss" scoped>
.raster-thumbnail-drawer {
  margin: 6px 8px;
  max-height: 100%;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid white;
  background-color: black;
}
</style>
